export const EVENTS = {
  INSERT: 'INSERT',
  REMOVE: 'REMOVE',
  MODIFY: 'MODIFY',
  DOMAIN_VERIFIED: 'DOMAIN_VERIFIED',
  REFRESH: 'REFRESH',
};
